import type { MarketBorrowersInput } from '../borrowers.contract'

export const PAGE_SIZE = 10

type MarketBorrowersSortBy = NonNullable<MarketBorrowersInput['sortBy']>

export const COLUMN_TO_SORT_BY: Partial<Record<string, MarketBorrowersSortBy>> = {
  health: 'healthFactor',
  totalCollateral: 'collateral',
  totalLoan: 'borrowShares',
  borrowShare: 'borrowShares'
}
